require.register("app/product/stat/AveragePriceView", function(exports, require, module){
  $0
  
});

